import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  newCustomers(data) {
    return api.post(`/api/v1/task/new-customers`, data);
  },
  maintenanceTasks(data) {
    return api.post(`/api/v1/task/maintenance`, data);
  },
  unknownTask(data) {
    return api.post(`/api/v1/task/index`, data);
  },
  globalSearch(data) {
    return api.get(`/api/v1/task/lite-index?${paramsFactory(data)}`);
  },
  trackingTask(data) {
    return api.post(`/api/v1/task/tracking`, data);
  },
  reasonList() {
    return api.get(`/api/v1/qa-maintenance/reason-list`);
  },
  checkFtthTicketNo(ftth_number) {
    return api.get(
      `/api/v1/task/check-status?ftth_ticket_number=${ftth_number}`,
    );
  },
  subscriptionRequestTasks(data) {
    return api.post(`/api/v1/task/subscription-request`, data);
  },
  fatClearanceTask(data) {
    return api.post(`/api/v1/task/clear-poles`, data);
  },
  createFatClearanceTask(data) {
    return api.post(`/api/v1/task/clearance`, data);
  },
  polesMaintenanceTask(data) {
    return api.post(`/api/v1/task/poles-maintenance`, data);
  },
  createPolesMaintenanceTask(data) {
    return api.post(`/api/v1/task/pole_maintenance`, data);
  },
  create(data) {
    return api.post(`/api/v1/task`, data);
  },
  showById(id) {
    return api.get(`/api/v1/task/${id}`);
  },
  status() {
    return api.get(`/api/v1/task/status`);
  },
  cancelReasons() {
    return api.get(`/api/v1/task/cancel-reasons`);
  },
  reply(data) {
    return api.post(`/api/v1/task-reply`, data);
  },
  assignResponsible(data) {
    return api.put(`/api/v1/task/assign-responsible/${data.task_id}`, data);
  },
  changeStatus(id, data) {
    return api.post(`/api/v1/task/change-status/${id}`, data);
  },
  update(data) {
    return api.put(`/api/v1/task/${data.id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/task/${id}`);
  },
  deleteReply(id) {
    return api.delete(`/api/v1/task-reply/${id}`);
  },
  solutions() {
    return api.get(`/api/v1/task/solutions`);
  },
  types() {
    return api.get(`/api/v1/task/type`);
  },
  addSolutions(task_id, data) {
    return api.post(`/api/v1/task/solutions/${task_id}`, data);
  },
  assignMultipleResponsible(data) {
    return api.put(`/api/v1/task/assign-multi-responsible`, data);
  },
  changeIsExternalStatus(data) {
    return api.put(`/api/v1/task/external/${data.id}`);
  },

  getTaskNotification() {
    return api.get(`/api/v1/task/statistics`);
  },
  changeSubscriptionRequests(id, data) {
    return api.put(`/api/v1/task/change-subscription/${id}`, data);
  },
  fastSubscribe(data) {
    return api.put(`/api/v1/task/collect-money/${data.task_id}`, data);
  },
  exportToExcel(data) {
    // const p = paramsFactory(params);
    return api.post(`/api/v1/task/new-customers`, data, {
      responseType: "blob",
    });
  },
  exportToExcelMaintenance(data) {
    // const p = paramsFactory(params);
    return api.post(`/api/v1/task/maintenance`, data, {
      responseType: "blob",
    });
  },
  assignTeamLeader(data) {
    return api.put(`/api/v1/task/assign-team-leader/${data.id}`, data);
  },
  getRecords(date) {
    return api.get(
      `/api/v1/task/get-records?start_date=${date.start_date}&end_date=${date.end_date}`,
      date,
    );
  },
  addNewRecord(data) {
    return api.post(`/api/v1/task-record`, data);
  },
  getRecordFullPath(path) {
    return api.post(
      `/api/v1/task-record/get`,
      { rec_path: path },
      { responseType: "blob" },
    );
  },
  //clearance task

  getCabels() {
    return api.get(`/api/v1/maintenance-page/cable-price`);
  },
  maintenanceDetailsPrice(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/task/check-price?${p}`);
  },
  maintenanceDetailsForm(id, data) {
    return api.post(`/api/v1/task/maintenance/${id}`, data);
  },

  getCollectionFees() {
    return api.get(`/api/v1/task/collection-fees`);
  },
  changeDelayed(data) {
    return api.put(`/api/v1/task/delayed`, data);
  },
  changeTaskTypeFromFtth(data) {
    return api.put(`/api/v1/task/change-type/${data.id}`, data);
  },
  changeToQuality(id) {
    return api.put(`/api/v1/task/change-to-quality/${id}`);
  },
};
